module.exports = __webpack_public_path__ + "static/media/site.c2f55242.webmanifest";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propertybooster-favicon/site.webmanifest
// module id = 287
// module chunks = 0